import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectDefault from '../common/form/selectDefault';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './racaoActions';
import Th from '../common/table/th';
import THead from '../common/table/tHead';
import Table from '../common/table/table';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Tr from '../common/table/tr';
import TBody from '../common/table/tBody';

class RacaoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {
		
		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe'
								cols='12 8 8 8'
								readOnly={readOnly} />

							<Field
								name='codigo_integracao'
								component={LabelAndInput}
								label='Código de Integração *' placeholder='Informe'
								cols='12 2 2 2'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='id_fase_producao'
								options={this.props.listaFaseProducao}
								component={Select}
								label='Fase de Produção *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='observacao'
								component={LabelAndInput}
								label='Observação' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='quantidade'
								component={LabelAndInputNumber}
								label='Quantidade *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={180}
								readOnly={readOnly}
								title='Quantidade utilizada na fórmula'
								casas={2} />

							<Field
								name='id_unidade_medida'
								options={this.props.listaUnidadeMedida}
								component={Select}
								label='Unidade de Medida *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={300}
								readOnly={readOnly} />
						</Row>

						{this.formula(readOnly)}

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }

	adicionarFormula() {

		let lista = this.props.formularioValues.itens;
		lista.push({
			idAux: new Date().getTime(),
			ativo: true,
			alteracao: true
		});		

		this.props.initForm({
			...this.props.formularioValues,
			itens: lista
		});

		this.setState({
			quantidadeItens: lista.filter(item => item.ativo).length
		});
	}

	alterarFormula(registro) {

		const lista = this.props.formularioValues.itens.map(item => {
			if ((item.id || item.idAux) == (registro.id || registro.idAux)) {
				return {
					...registro,
					alteracao: true
				}
			} else {
				return item;
			}
		});

		this.props.initForm({
			...this.props.formularioValues,
			itens: lista
		});

		this.setState({
			quantidadeItens: lista.filter(item => item.ativo).length
		});
	}

	excluirFormula(registro) {
		if (registro.id) {
			this.alterarFormula({
				...registro,
				alteracao: true,
				ativo: false
			});
		} else {
			const lista = this.props.formularioValues.itens.filter(item => (item.id || item.idAux) != (registro.id || registro.idAux));

			this.props.initForm({
				...this.props.formularioValues,
				itens: lista
			});

			this.setState({
				quantidadeItens: lista.filter(item => item.ativo).length
			});
		}
	}

	formula(readOnly) {

		return (
			<>
				<ContentCard>
					<ContentCardHeader>
						<h3 class='card-title'>
							<i class='fas fa-flask mr-1'></i>
							Fórmula {this.state.quantidadeItens ? `(${this.state.quantidadeItens})` : ''}
						</h3>
						<div class='card-tools' 
							style={{ paddingRight: 12 }}>
							<button type='button'
								class='btn btn-success btn-sm'
								title='Adicionar'
								onClick={() => this.adicionarFormula()}>
								<i class='fas fa-plus'></i>
							</button>
						</div>
					</ContentCardHeader>
					<ContentCardBody>
						<Table responsive>
							<THead>
								<Tr>
									<Th width={200} alignCenter>Matéria Prima</Th>
									<Th width={100} alignCenter>Quantidade</Th>
									<Th width={100} alignCenter>Unidade de Medida</Th>
									<Th width={300} alignCenter>Observação</Th>
									<Th width={10}></Th>
								</Tr>
							</THead>
							<TBody>
								{this.props.formularioValues.itens.filter(item => item.ativo).map(formula => (
									<Tr key={formula.id || formula.idAux}
										backgroundColor={!formula.id_materia_prima || !formula.quantidade || !formula.id_unidade_medida ? '#f57373' : '#bae8cc'}>
										<Td alignCenter>
											<SelectDefault
												options={this.props.listaMateriaPrima}
												label={null} placeholder='Informe'
												cols='12 12 12 12'
												paddingBottom={0}
												marginBottom={0}
												readOnly={readOnly}
												value={formula.id_materia_prima}
												onChange={data => {
													this.alterarFormula({
														...formula,
														id_materia_prima: data.target.value
													})
												}} />
										</Td>
										<Td alignCenter>
											<LabelAndInputNumber
												label={null} placeholder='Informe'
												cols='12 12 12 12'
												paddingBottom={0}
												marginBottom={0}
												readOnly={readOnly}
												casas={2}
												value={formula.quantidade}
												onChange={data => {
													this.alterarFormula({
														...formula,
														quantidade: data.target.value
													});
												}} />
										</Td>
										<Td alignCenter>
											<SelectDefault
												options={this.props.listaUnidadeMedida}
												label={null} placeholder='Informe'
												cols='12 12 12 12'
												paddingBottom={0}
												marginBottom={0}
												readOnly={readOnly}
												value={formula.id_unidade_medida}
												onChange={data => {
													this.alterarFormula({
														...formula,
														id_unidade_medida: data.target.value
													});
												}} />
										</Td>
										<Td alignCenter>
											<LabelAndInput
												label={null} placeholder='Informe'
												cols='12 12 12 12'
												paddingBottom={0}
												marginBottom={0}
												readOnly={readOnly}
												value={formula.observacao}
												onChange={data => {
													this.alterarFormula({
														...formula,
														observacao: data.target.value
													});
												}} />
										</Td>
										<Td alignCenter>
											<button type='button'
												class='btn btn-danger btn-sm'
												title='Remover'
												onClick={() => this.excluirFormula(formula)}>
												<i class='fas fa-times'></i>
											</button>
										</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</ContentCardBody>
				</ContentCard>
			</>
		);
	}

}

RacaoForm = reduxForm({form: 'racaoForm', destroyOnUnmount: false})(RacaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('racaoForm')(state),
	registro: state.racao.registro,
	listaFaseProducao: state.faseProducao.listaSelect,
	listaUnidadeMedida: state.unidadeMedida.listaSelect,
	listaMateriaPrima: state.materiaPrima.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(RacaoForm);
